module.exports = __webpack_public_path__ + "static/media/amenity_kitchen.8998b3fd.jpg";